"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactTextInput = _interopRequireDefault(require("@adsk/alloy-react-text-input"));
var _alloyReactFormField = _interopRequireDefault(require("@adsk/alloy-react-form-field"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _i18n = require("../../../../i18n");
var _constants = require("../../constants");
var _useErrorValidation = _interopRequireDefault(require("./useErrorValidation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TitleInput = _ref => {
  let {
    value,
    onChange
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  const {
    errors,
    errorMessage
  } = (0, _useErrorValidation.default)(value);
  const label = T.translate('form.label.title');
  const placeholder = T.translate('form.placeholder.title');
  return /*#__PURE__*/_react.default.createElement(_alloyReactFormField.default, {
    error: errorMessage,
    label: label,
    labelVariant: _alloyReactFormField.default.LABEL_VARIANTS.TOP,
    required: true
  }, /*#__PURE__*/_react.default.createElement(StyledTextInput, {
    placeholder: placeholder,
    value: value,
    error: Boolean(errors[_constants.NAME]),
    onChange: _ref2 => {
      let {
        target
      } = _ref2;
      const {
        value
      } = target;
      onChange(value);
    }
  }));
};
const StyledTextInput = (0, _styledComponents.default)(_alloyReactTextInput.default)`
  input {
    box-sizing: border-box;
  }
`;
TitleInput.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired
};
var _default = exports.default = TitleInput;